import { Switch } from '@mui/material'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { getPropertyName } from '../../helpers/utils'
import BaseElement from './BaseElement'

const SwitchMutator = ({ definition, value, parent, itemKey, buttons, handleUpdate }) => {
  const [controlledValue, setValue] = useState(!!value)
  const title = useMemo(() => getPropertyName(definition?.title, itemKey), [definition, itemKey])

  const handleChange = useCallback((_, newValue) => {
    if (value !== newValue) {
      setValue(newValue)
      handleUpdate(newValue)
    }
  }, [handleUpdate, value])

  useEffect(() => {
    setValue(value)
  }, [value])

  return (
    <BaseElement error={!definition}>
      <header-area>
        <span>{title}</span>
        <div>
          {buttons}
        </div>
      </header-area>
      <Switch
        checked={controlledValue}
        color={definition ? 'info' : 'error'}
        onChange={handleChange}
        size="small"
      />
    </BaseElement>
  )
}

export default SwitchMutator